<template>
  <el-dialog width="35%" class="dialog" :title="pageType === 'add'?'创建角色': '编辑角色'" :visible.sync="dialogFormVisible">
    <el-form ref="ruleForm" label-position="right" :rules="rules" :model="formData" label-width="120px">

      <el-form-item label="父级" prop="parentId">
        <el-select style="width:100%;" v-model="formData.parentId" placeholder="请选择父级">
          <el-option v-for="item in parentIdList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="formData.roleName" :maxLength="50" placeholder="请输入角色名称" auto-complete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="所属组织" prop="partnershipId">
        <BelongOrgSelect style="width:100%;" v-model="formData.partnershipId"></BelongOrgSelect>
      </el-form-item> -->
      <el-form-item label="角色描述" prop="description">
        <el-input type="textarea" v-model="formData.description" placeholder="请输入角色描述" :maxLength="100"></el-input>
      </el-form-item>
      <el-form-item label="角色权限" prop="menuIdList">
        <el-checkbox-group v-model="menuListControl">
          <el-checkbox label="选中全部"></el-checkbox>
          <el-checkbox label="展开全部"></el-checkbox>
        </el-checkbox-group>
        <el-tree ref="tree" :data="menuListData" :expand-on-click-node="false" show-checkbox node-key="id"
          :props="defaultProps">
        </el-tree>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import BelongOrgSelect from '@/components/BelongOrgSelect'
export default {
  components: {
    BelongOrgSelect
  },
  props: {
    orgTypeList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      /**
       * pageType 弹框类型 add | edit
       * dialogFormVisible 弹框状态
       * parentIdList 父级下拉选择列表
       * menuListControl 菜单权限 选中全部， 展开全部控制
       * formData 表单数据
       * rules 表单规则
       * menuListData 角色权限提供选择的菜单权限列表数据
       * defaultProps 树形选择默认属性
       * allCheckId 菜单权限列表数据所有的节点id，用于选中全部
       * editRowDataId 当前页面类型为编辑时的角色id
       * AllHasChildNodeIds 所有包含子节点的菜单列表数据id，用于编辑筛选父级不选中
       */
      pageType: 'add',
      dialogFormVisible: false,
      parentIdList: [],
      menuListControl: [],
      formData: {
        parentId: '',
        roleName: '',
        partnershipId: '',
        description: '',
        menuIdList: []
      },
      rules: {
        parentId: [
          { required: true, message: '请选择父级', trigger: 'blur' },
        ],
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
        partnershipId: [
          { required: true, message: '请选择所属组织', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入角色描述', trigger: 'blur' },
        ],
        menuIdList: [
          { required: true, message: '请选择角色权限', trigger: 'blur' },
        ],
      },
      menuListData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      allCheckId: [],
      editRowDataId: '',
      AllHasChildNodeIds: [],
      btnLoading: false
    }
  },
  watch: {
    menuListControl: {
      handler: function (val) {
        let isCheckAll = val.includes('选中全部')
        let isExpandAll = val.includes('展开全部')
        if (!isCheckAll) {
          this.$refs.tree.setCheckedKeys([])
        } else {
          this.allCheckId = []
          this.selectAllNodes(this.menuListData)
          this.$refs.tree.setCheckedKeys(this.allCheckId)
        }
        // 展开或者关闭全部
        var treeNodeList = this.$refs.tree.store._getAllNodes();
        for (var i = 0; i < treeNodeList.length; i++) {
          treeNodeList[i].expanded = isExpandAll
        }
      },
      deep: true
    },
    'formData.parentId': function (val) {
      if (val) {
        // 每一次获取所有的可选菜单重置勾选为空
        this.$refs.tree.setCheckedKeys([])
        this.getMenuListForRolesId()
      }
    },
    dialogFormVisible: function (val) {
      if (!val) {
        this.resetFormStatus()
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog () {
      this.dialogFormVisible = false
    },
    // 打开弹框
    openDialog (pageType = 'add', rowData) {
      this.pageType = pageType
      this.getMenuListForRolesId()
      this.getParentIdList()
      // 如果是编辑
      if (pageType === 'edit') {
        this.editRowDataId = rowData.id
        this.editGetHasMenuListAuth(this.editRowDataId)
      }
      this.dialogFormVisible = true
    },
    // 确认提交
    submitBtnFun () {
      // 获取全选值
      const menuIdList = this.$refs.tree.getCheckedKeys()
      // 获取半选值
      const halfMenuList = this.$refs.tree.getHalfCheckedKeys()
      this.formData.menuIdList = [...menuIdList, ...halfMenuList]
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.saveRoleReq()
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 表单重置
    resetFormStatus () {
      this.$refs.tree.setCheckedKeys([])
      this.$refs.ruleForm.resetFields()
    },
    // 添加或者编辑请求
    saveRoleReq () {
      const params = this.formData
      params.status = 0
      const addUrl = `/autoapp-recovery-server-auth/api/tbl-role/addRole`
      const editUrl = `/autoapp-recovery-server-auth/api/tbl-role/updateRole`
      const url = this.pageType === 'add' ? addUrl : editUrl
      if (this.editRowDataId) {
        params.id = this.editRowDataId
      }
      this.HttpService.post(url, params).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          // console.log('=====res===', res)
          const tipMsg = this.pageType === 'add'? '新增成功' : '编辑成功'
          this.$message.success(tipMsg)
          this.$emit('opera-success')
          this.closeDialog()
          this.resetFormStatus()
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
    // 获取父级角色对应的所有菜单权限列表
    getMenuListForRolesId () {
      // const roleId = this.formData.parentId || this.$store.getters.roleId
      // const url = `/autoapp-recovery-server-auth/api/tbl-sys-menu/treeSelectByRole?roleId=${roleId}`
      const url = `/autoapp-recovery-server-auth/api/tbl-sys-menu/treeSelectByRole`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('=====res===', res)
          const resData = res.data
          this.menuListData = resData.menus || []
          // 有children父级id列表
          this.AllHasChildNodeIds = []
          this.getAllHasChildNodeIds(this.menuListData)
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
    // 获取父级角色下拉选择
    getParentIdList () {
      const url = `/autoapp-recovery-server-auth/api/tbl-role/listChildrenRoleIds`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.parentIdList = res.data || []
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
    // 获取该编辑角色拥有的菜单权限
    editGetHasMenuListAuth (id) {
      const url = `/autoapp-recovery-server-auth/api/tbl-role/queryRole?id=${id}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          const roleDetInfo = res.data.faRole
          const menuIdList = res.data.menuIdList
          // 初始赋值
          for (let item in this.formData) {
            this.formData[item] = roleDetInfo[item]
          }
          // 筛选掉父级避免导致子级全选, 编辑勾选数据在获取下拉可选重置勾选为空之后
          this.$nextTick(() => {
            const filterParentMenuIdList = menuIdList.filter((item)=> !this.AllHasChildNodeIds.includes(item))
            this.$refs.tree.setCheckedKeys(filterParentMenuIdList)
          })
        } else {
          const tipMsg = res.message || '请求出错'
          this.$message.error(tipMsg)
        }
      })
    },
    // 获取所有节点
    selectAllNodes (nodes) {
      for (const node of nodes) {
        this.allCheckId.push(node.id); // 假设节点的唯一标识是 id
        if (node.children && node.children.length > 0) {
          this.selectAllNodes(node.children);
        }
      }
    },
    // 获取所有有子级的节点id
    getAllHasChildNodeIds (nodes) {
      for (const node of nodes) {
        if (node.children && node.children.length >0) {
          this.AllHasChildNodeIds.push(node.id)
          this.getAllHasChildNodeIds(node.children)
        }
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/AddOrEditRole.vue